module.exports = "/assets/data/db77c2b28d1de4351a282d1ffa185ef7-M30.data.json";